import { httpClient } from '@/services/http/httpClient'

export type CreateCommentRequest = {
  commentListId: string
  videoId?: number
  text: string
}

type CommentResponse = {
  id: string
  text: string
  likes: number
  commentListId: string
  userId: string
  createdAt: string
}

export async function createComment({
  commentListId,
  text,
  videoId,
}: CreateCommentRequest) {
  return await httpClient.post<CommentResponse>('/users/videos/comments', {
    commentListId,
    text,
    videoId,
  })
}
